import React from "react";
import CreateRoles from "./CreateRoles";

const PageRole = () => {
  return (
    <>
      <CreateRoles />
    </>
  );
};
export default PageRole;
